import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlpitranslatePipe } from './pipes/alpitranslate.pipe';
import { PlatformassetPipe, PlatformManagerModule } from '../../../projects/platform-manager/src/public_api';
import { environment } from '../../environments/environment';
import { DeferLoadModule } from '@trademe/ng-defer-load';

export const config = {
  production: environment.production,
  env: environment.env,
  hostname: environment.hostname,
  payment_hostname: environment.payment_hostname,
  language: environment.language,
  api_endpoints: environment.api.url,
  platform: environment.platform,
  platformFallback: environment.platformFallback,
  asset_path: environment.language_path,
  ekomi_widget: environment.ekomi_widget,
  sales: environment.sales
};

@NgModule({
  providers: [AlpitranslatePipe],
  imports: [
    CommonModule,
    DeferLoadModule,
    PlatformManagerModule.forRoot(config),
    AlpitranslatePipe,
    PlatformassetPipe
  ],
  exports: [
    CommonModule,
    PlatformManagerModule, // TODO: replace core module imports with PlatformManagerModuel.forFeature()
    AlpitranslatePipe, // TODO: replace all import for core module with imports for AlpitranslatePipe
    PlatformassetPipe
  ]
})
export class CoreModule {}
